function isSupportPassiveListener() {
  var supportsPassiveOption = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function() {
          supportsPassiveOption = true;
        }
      })
    );
  } catch (e) {}
  return supportsPassiveOption;
}

const APITest = {
  isSupportPassiveListener
};

export default APITest;
